import Typography from '@material-ui/core/Typography';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Container from '../../UI/atoms/Container';
import Text from '../../UI/atoms/Text';
import Line from '../../UI/atoms/Line';
import Grid from '../../UI/atoms/Grid';
import Button from '../../UI/atoms/Button';
import TextField from '../../UI/atoms/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import DatePicker, { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';
import { Link, useLocation } from 'react-router-dom';
import Tooltip from 'components/UI/atoms/Tooltip';
registerLocale('ko', ko);

const Styles = styled.div`
  padding: 1rem;

  table {
    border-spacing: 0;
    border: 1px solid #ddd;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid #ddd;
      border-right: 1px solid #ddd;

      :last-child {
        border-right: 0;
      }
    }
  }
`;
export default function Presenter({ excelDownloadEvent, yesterDay, allDataSumColumns, allDataSumData, columns, rows }: any) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Container>
      {/* <Grid top={30} bottom={10}>
        <Text fontSize="2rem" fontWeight={600} color="#444">
          PLAYAPI 통계관리
        </Text>
        <Link to={statisticsPath}>통계</Link>|<Link to={dashboardPath}>상세조회</Link>
      </Grid>
      <Line color="#e8e8e8" /> */}
      <TableContainer style={{ overflowX: 'visible' }}>
        <Styles>
          <Text fontSize="30px" fontWeight={600} color="#444">
            전체 통계
          </Text>
          <Table>
            <TableHead>
              <TableRow>
                {Object.entries(allDataSumColumns).map(([key, value]: any) => (
                  <TableCell style={{ fontWeight: 'bold' }} align="center">
                    {key}
                    <Tooltip title={value}>
                      <Grid color="#f2f4f7" left={5} right={5}>
                        ?
                      </Grid>
                    </Tooltip>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align="center">{allDataSumData.joinSellerCountAll}</TableCell>
                <TableCell align="center">{allDataSumData.prodCountAll}</TableCell>
                <TableCell align="center">{allDataSumData.migrationFirstSellerCountAll}</TableCell>
                <TableCell align="center">{allDataSumData.migrationSellerCountAll}</TableCell>
                <TableCell align="center">{allDataSumData.sellerAverageProdCountAll}</TableCell>
                <TableCell align="center">{allDataSumData.successRateAll}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Styles>
        <Styles>
          <Grid display="flex" justifyContent="space-between" alignItems="center">
            <Text fontSize="30px" fontWeight={600} color="#444">
              주간 통계
            </Text>
            <Button type="button" color="main" variant="outlined" size="small" width={120} onClick={excelDownloadEvent}>
              엑셀 다운로드
            </Button>
          </Grid>
          <Table>
            <TableHead>
              <TableRow>
                {Object.entries(columns).map(([key, value]: any) => (
                  <TableCell style={{ fontWeight: 'bold' }} align="center" size="small">
                    {key}
                    {key !== '날짜' ? (
                      <Tooltip title={value}>
                        <Grid color="#f2f4f7" left={2} right={2}>
                          ?
                        </Grid>
                      </Tooltip>
                    ) : (
                      ''
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0 ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : rows).map((one: any) => (
                <TableRow key={one.index}>
                  <TableCell align="center">{one.day}</TableCell>
                  <TableCell align="center">{one.joinSellerCount}</TableCell>
                  <TableCell align="center">{one.prodCount}</TableCell>
                  <TableCell align="center">{one.migrationFirstSellerCount}</TableCell>
                  <TableCell align="center">{one.migrationSellerCount}</TableCell>
                  <TableCell align="center">{one.sellerAverageProdCount}</TableCell>
                  <TableCell align="center">{one.successRate}</TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Styles>
      </TableContainer>
    </Container>
  );
}
